import { Component, OnInit } from "@angular/core";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "appfolio-welcome",
  templateUrl: "./appfolio-welcome.component.html",
  styleUrls: ["./appfolio-welcome.component.css"],
})
export class AppFolioWelcomeComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    localStorage.setItem("sessionId", null);
    localStorage.setItem("appfolioFirstRegistrationDetails", null);
    localStorage.setItem("appfolioSigUpCompany", null);
  }
}
